import { MachineContext } from '../list/context/brandReviewsMachine'
import { DEFAULT_SORT_OPTION } from './sortOrder'

export enum BrandReviewsUrlParam {
  BRAND_PRODUCT_IDS = 'bp',
  RATING = 'r',
  ORDER = 'o',
  PAGE = 'p'
}

export const buildReviewFilterPath = (ctx: MachineContext) => (brandSlug: string) => {
  const { brandProductIds, order, page, rating } = ctx
  const params = new URLSearchParams()

  const path = `/brands/${brandSlug}/reviews`

  if (order.key !== DEFAULT_SORT_OPTION.key) {
    params.set(BrandReviewsUrlParam.ORDER, order.paramName)
  }

  if (rating) {
    params.set(BrandReviewsUrlParam.RATING, rating)
  }

  if (page > 1) {
    params.set(BrandReviewsUrlParam.PAGE, page.toString())
  }

  if (brandProductIds.length > 0) {
    params.set(BrandReviewsUrlParam.BRAND_PRODUCT_IDS, brandProductIds.join(','))
  }

  const queryString = params.toString()
  if (queryString) {
    return `${path}?${queryString}`
  } else {
    return path
  }
}
